import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var promoCodeSchema = {
    code: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на промо кода *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име на промо кода',
    }),
    maximum_uses: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
        }),
        elementType: 'input',
        label: 'Максимален брой използвания *',
        value: 50,
        validation: {
            required: false
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валидна брой',
    }),
    discount_type: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control category-dropdown',
            placeholder: '',
            options: [
                { label: 'Процент', value: 'percent' },
                { label: 'Стойност', value: 'amount' }
            ]
        }),
        elementType: 'dropdown',
        label: 'Тип на промо код *',
        validation: {
            required: true
        },
        value: '',
        valid: false,
        touched: false,
        hidden: true
    }),
    discount_value: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
        }),
        elementType: 'input',
        label: 'Стойност на отстъпката *',
        value: 1,
        validation: {
            required: false
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валидна цтойност',
    }),
    only_logged_users: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'inputSwitch',
        label: 'Само за логнати потребители',
        value: '',
        validation: {
            required: false
        },
        valid: false,
        touched: false,
        errorMsg: '',
    }),
    unique_per_user: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'inputSwitch',
        label: 'Само за уникални за потребител',
        value: '',
        validation: {
            required: false
        },
        valid: false,
        touched: false,
        errorMsg: '',
    }),
    brand_ids: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            multiple: true,
        }),
        elementType: 'autocomplete',
        label: 'Марки',
        value: [],
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидна марка',
    }),
    category_id: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'autocomplete',
        label: 'Категория',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидна категория',
    }),
    begin_date: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            dateFormat: "yy-dd-mm",
        }),
        elementType: 'datepicker',
        label: 'Дата на влизане на сила на промо кода',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете начална дата',
    }),
    begin_date_time: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'time',
            defaultValue: '00:00',
        }),
        elementType: 'input',
        label: 'Час на влизане на сила на промо кода',
        value: '',
        validation: {
            required: false,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете часа',
    }),
    end_date: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            dateFormat: "yy-dd-mm",
        }),
        elementType: 'datepicker',
        label: 'Дата на изтичане на промо кода',
        value: '',
        validation: {
            required: false,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете крайна дата',
    }),
    end_date_time: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'time',
        }),
        elementType: 'input',
        label: 'Час на изтичане на промо кода',
        value: '',
        validation: {
            required: false,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете часа',
    })
};
export default promoCodeSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/promoCodeSchema.ts
// module id = 412
// module chunks = 0